import { render } from "./matching.vue?vue&type=template&id=75144093&scoped=true&lang=pug"
import script from "./matching.vue?vue&type=script&setup=true&lang=js"
export * from "./matching.vue?vue&type=script&setup=true&lang=js"

import "./matching.vue?vue&type=style&index=0&id=75144093&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75144093"]])

export default __exports__